import React from 'react';

import { Global, SerializedStyles } from '@emotion/react';

import { normalizeStyles } from './normalize';
import { global } from './styles';

export type StyleTheme = {
    body: {
        color: string;
        fontFamily: string;
        backgroundColor: string;
    };
    headings: {
        fontFamily: string;
    };
    buttons?: {
        boxed?: {
            backgroundColor: string;
            backgroundColorOnHover: string;
            color: string;
            colorOnHover: string;
        };
    };
    versionSpecificGlobalStyles?: SerializedStyles;
};

/**
 * Global styles that are supposed to be applied to every page
 * injected via @emotion global.
 *
 * It also contains a normalize,
 */
export const GlobalStyles = () => {
    return (
        <>
            <Global styles={normalizeStyles} />
            <Global styles={global} />
        </>
    );
};
